import React from 'react';
import PropTypes from 'prop-types';
import {motion, AnimatePresence} from 'motion/react';

const fadeEnd = {
  opacity: 1,
};

const fadeStart = {
  opacity: 0,
};

function Fade({
  children,
  show = false,
  withAnimatePresence = true,
  fadeOut = true,
  uuid = null,
}) {
  if (withAnimatePresence && fadeOut) {
    return (
      <AnimatePresence exitBeforeEnter={fadeOut}>
        {show && (
          <motion.div
            initial={fadeStart}
            animate={fadeEnd}
            exit={fadeStart}
            transition={{delay: 0, duration: 0.15, ease: 'easeOut'}}
            {...(uuid ? {key: uuid} : {})}>
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    );
  }

  if (show) {
    return (
      <motion.div
        initial={fadeStart}
        animate={fadeEnd}
        exit={fadeOut ? fadeStart : null}
        transition={{delay: 0, duration: 0.15, ease: 'easeOut'}}
        {...(uuid ? {key: uuid} : {})}>
        {children}
      </motion.div>
    );
  }
  return null;
}

Fade.propTypes = {
  children: PropTypes.node.isRequired,
  show: PropTypes.bool,
  withAnimatePresence: PropTypes.bool,
  fadeOut: PropTypes.bool,
  uuid: PropTypes.string,
};

export default Fade;
